module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_63-5851a90f9f1af320205f2d9a00fc8dd7.png";